<template>
  <div class="news-top">
    <div class="news-top__title">Архив новостей</div>
    <div class="news-top__selects">
      <div class="default-select" :class="{'active' : selectedYear}">
        <select ref="years" v-model="selectedYear" @change="setFilter" class="default-select__select">
          <option></option>
          <option v-for="year in years" :key="year" :value="year" v-html="year"></option>
        </select>
        <div class="default-select__label">Выберите год</div>
      </div>
      <div class="default-select" :class="{'active' : selectedMonth}">
        <select ref="months" v-model="selectedMonth"  @change="setFilter" class="default-select__select">
          <option></option>
          <option v-for="(month, key) in months" :key="key" :value="key" v-html="month"></option>
        </select>
        <div class="default-select__label">Выберите месяц</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name  : "NewsFilter",
  props : {
    years        : {
      type    : Array,
      default : () => []
    },
    months       : {
      type    : Array,
      default : () => []
    },
    currentYear  : {
      type    : String,
      default : ""
    },
    currentMonth : {
      type    : String,
      default : ""
    }
  },
  data()
  {
    return {
      selectedYear  : "",
      selectedMonth : ""
    };
  },
  methods : {
    setFilter()
    {
      if(!this.selectedYear)
      {
        return;
      }
      let params = '';
      if(this.selectedYear)
      {
        params += (params.length > 0 ? "&year=" : "?year=") + this.selectedYear;
      }
      if(this.selectedMonth)
      {
        params += (params.length > 0 ? "&month=" : "?month=") + this.selectedMonth;
      }
      window.location.search = params;
    }
  },
  mounted()
  {
    this.selectedYear  = this.currentYear;
    this.selectedMonth = this.currentMonth;
  }
};
</script>

<style scoped>

</style>